import apiClient from '@u/apiClient.js'

export default {
  setType: ({ commit }, payload) => {
    commit('setType', payload)
  },
  setFilters: ({ commit }, payload) => {
    commit('setFilters', payload)
  },
  setXAxis: ({ commit }, payload) => {
    commit('setXAxis', payload)
  },
  getAnalyticsForDashboardData: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`analytics-dashboard/${payload.id}/analytics-data`, payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getAnalyticsData: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`/analytics/analytics-data`, payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getInvoiceItemStatistics: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`/analytics/invoice-item/statistics`, payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getInvoicingStatistics: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`/analytics/invoicing/statistics`, payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
